import './newsletter.scss';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { CTAButton } from 'components/atoms/Button/Button';
import { useIsMobile, getResponsiveImageUrl } from 'helpers/ui';
import { FallbackImage } from '@rcw/ui';
import DOMPurify from 'dompurify';
import {
  Modal, Icon, Loader, Dimmer,
} from 'semantic-ui-react';

export default function Newsletter({ data }) {
  const newsletterData = data;
  const [showIframe, setShowIframe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const isMobile = useIsMobile();

  const handleSubscribeClick = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setShowIframe(true);
  };

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className='newsletterContainer'>
      <div className='imgContainer'>
        <FallbackImage
          src={getResponsiveImageUrl(newsletterData.imageUrl, newsletterData.mobileImageUrl, isMobile)}
          fallbackSrc={newsletterData.imageUrl}
          alt={DOMPurify.sanitize(newsletterData.title, { ALLOWED_TAGS: [] })}
          fetchPriority='high'
        />
        <div className='imgOverlay' />
      </div>

      <div
        className='newsletterContainer_data'
        style={{
          textAlign: newsletterData.alignment,
          alignItems: newsletterData.alignment,
        }}
      >
        <div className='newsletterContainer_labels'>
          <div
            className='newsletterContainer_title proxima-nova-bold'
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(newsletterData.title) }}
          />
          <div className='newsletterContainer_body' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(newsletterData.body) }} />
        </div>

        <form className='form' onSubmit={handleSubscribeClick}>
          <div className='ctaContainer'>
            <CTAButton
              className='subscribeBtn'
              ctaText={newsletterData.ctaText}
              type='submit'
            />
          </div>
        </form>

        <Modal
          onClose={() => setShowIframe(false)}
          open={showIframe}
          size='large'
          style={{ zIndex: 10001 }}
          className='newsletterModal'
        >
          <button
            type='button'
            aria-label='Close newsletter signup'
            className='close_icon'
            onClick={() => setShowIframe(false)}
          >
            <Icon
              name='close'
              color='black'
              style={{ fontSize: '18px' }}
            />
          </button>

          <div className='iframeWrapper'>
            {isLoading && (
              <Dimmer active inverted>
                <Loader size='large' content='Setting the stage...' />
              </Dimmer>
            )}

            {showIframe && (
              <iframe
                src='https://roland.activehosted.com/f/1153'
                title='Newsletter Signup'
                width='100%'
                height='100%'
                frameBorder='0'
                scrolling='auto'
                onLoad={handleIframeLoad}
                style={{
                  opacity: isLoading ? 0 : 1,
                  transition: 'opacity 0.3s ease',
                }}
              />
            )}
          </div>
        </Modal>
      </div>
    </div>
  );
}

Newsletter.propTypes = {
  data: PropTypes.shape({
    enabled: PropTypes.bool,
    order: PropTypes.number,
    imageUrl: PropTypes.string,
    mobileImageUrl: PropTypes.string,
    title: PropTypes.string,
    body: PropTypes.string,
    ctaText: PropTypes.string,
    ctaUrl: PropTypes.string,
    alignment: PropTypes.string,
  }),
};
